import { useParams } from 'react-router';

import { EAdmissionTestingStatus, useGetAdmissionTestingQuery } from '@/api/endpoints/schools/schoolSelectionPanel';
import type { IApiError } from '@/api/types';
import { ESelectionPanelTabs } from '@/pages/(publicPages)/(schools)/(schoolSelectionPanel)/_components/SelectionPanelHeader/consts';
import { SelectionPanelHeader } from '@/pages/(publicPages)/(schools)/(schoolSelectionPanel)/_components/SelectionPanelHeader/SelectionPanelHeader';
import { UnavailableSection } from '@/pages/(publicPages)/(schools)/(schoolSelectionPanel)/_components/UnavailableSection/UnavailableSection';
import styles from '@/pages/(publicPages)/(schools)/(schoolSelectionPanel)/TestingTab/(pages)/TestingParticipantsPage/TestingParticipantsPage.module.scss';
import { FetchErrorSection, Loader } from '@/shared/components';

import { EnrolledListPage } from './EnrolledListPage';

export const EnrolledListPageWrapper = () => {
  const { id: schoolId } = useParams();

  const {
    data: admissionTestingData,
    isLoading: isTestingLoading,
    isError: isTestingFetchError,
    error: testingError,
  } = useGetAdmissionTestingQuery({ schoolId: Number(schoolId) });

  if (isTestingLoading) {
    return <Loader isSpinning />;
  }

  const isNotFound = (testingError as IApiError)?.status === 404;

  if (isTestingFetchError && !isNotFound) {
    return <FetchErrorSection />;
  }

  if (isNotFound || admissionTestingData?.status !== EAdmissionTestingStatus.Finished) {
    return (
      <div className={styles.wrapper}>
        <SelectionPanelHeader currentTab={ESelectionPanelTabs.Enrolled} />
        <UnavailableSection unavailableText="Данная секция станет доступна после прохождения тестирования" />
      </div>
    );
  }

  return <EnrolledListPage schoolId={Number(schoolId)} />;
};
